module.exports = __webpack_public_path__ + "static/media/compress.21bab487.svg";